export default function initSearchProducts() {
    // TRAVA DE SEGURANÇA: Só executa este script na página de categorias de produtos
    if (!document.body.classList.contains('tax-categoria-produto')) {
        return;
    }

    const customInput = document.getElementById('custom-search-input');

    // Procura o input de texto original (escondido) do Ajax Search Pro
    const aspHiddenInput = document.querySelector('.c-grid-area__asp-hidden input.orig');

    // Seletores adicionados para manipular os filtros
    const customCheckboxes = document.querySelectorAll('.c-filter-item input');
    const aspCheckboxes = document.querySelectorAll('.c-grid-area__asp-hidden input[type="checkbox"]');
    const countDisplay = document.querySelector('.js-filter-count');

    if (!customInput || !aspHiddenInput) return;

    // --- INJEÇÃO DE CONTEXTO DA TAXONOMIA ---
    const aspForm = document.querySelector('.c-grid-area__asp-hidden form');
    const termIdInput = document.getElementById('js-current-term-id');
    const termTaxInput = document.getElementById('js-current-term-tax');

    if (aspForm && termIdInput && termTaxInput) {
        termIdInput.name = 'pdr_current_term_id';
        termTaxInput.name = 'pdr_current_term_tax';

        aspForm.appendChild(termIdInput);
        aspForm.appendChild(termTaxInput);
    }
    // ----------------------------------------

    let debounceTimer;

    customInput.addEventListener('input', (event) => {
        const searchTerm = event.target.value;

        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {

            if (searchTerm.trim().length > 0) {
                let hasCleared = false;

                customCheckboxes.forEach(cb => {
                    if (cb.checked) {
                        cb.checked = false;
                        hasCleared = true;
                    }
                });

                if (hasCleared) {
                    aspCheckboxes.forEach(cb => {
                        if (cb.checked) {
                            cb.checked = false;
                            cb.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    });

                    if (countDisplay) {
                        countDisplay.textContent = '0';
                    }
                }
            }

            aspHiddenInput.value = searchTerm;
            aspHiddenInput.dispatchEvent(new Event('input', { bubbles: true }));

            if (window.ASP && window.ASP.api) {
                window.ASP.api(5, 'search');
            }

        }, 500);
    });
}